import "./App.css";
import Weather from "./components/weather";
import logo from "./weather-icon-png-11063_skyclim_logo2.png";

function App() {
  return (
    <div className="App">
      <div className="title">
        <img src={logo} alt="Skyclim Logo" className="logo" />
        <h1>Skyclim</h1>
      </div>
      <Weather />
    </div>
  );
}

export default App;
